///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import HeaderCell from "../../../HeaderCell";
import messages from "../../../../helpers/messages";
import { sortShipperHistory } from "../../../../slices/bidSummarySlice";
import getSortOrder from "../../../../helpers/getSortOrder";

const TableHeader = () => {
  const dispatch = useDispatch();
  const { shipperHistorySort: sortDetails, summary } = useSelector(
    state => state.bidSummary
  );

  const sortBids = ({ fieldName }) => {
    const order = getSortOrder(fieldName, sortDetails.field, sortDetails.order);
    const sortParams = {
      field: order ? fieldName : "",
      order: order
    };
    dispatch(sortShipperHistory(sortParams));
  };

  return (
    <thead data-testid="table-header">
      <tr className="header-row bg-white">
        <HeaderCell
          label={messages.status.defaultMessage}
          maxWidth="104px"
          fieldName="statusText"
          sortBids={sortBids}
          sortField={sortDetails.field}
          sortOrder={sortDetails.order}
        />
        <HeaderCell
          label={!summary?.isCoyoteBid ? messages.uniqueBidName.defaultMessage : messages.rfqName.defaultMessage}
          maxWidth="120px"
          fieldName="bidName"
          sortBids={sortBids}
          sortField={sortDetails.field}
          sortOrder={sortDetails.order}
        />
        <HeaderCell
          label={!summary?.isCoyoteBid ? messages.pricingLaunchDate.defaultMessage : messages.openDate.defaultMessage}
          maxWidth="100px"
          fieldName="openDateUTC"
          sortBids={sortBids}
          sortField={sortDetails.field}
          sortOrder={sortDetails.order}
        />
        <HeaderCell
          label={!summary?.isCoyoteBid ? messages.pricingDueDateWithoutDate.defaultMessage : messages.closeDate.defaultMessage}
          maxWidth="110px"
          fieldName="closeDateUTC"
          sortBids={sortBids}
          sortField={sortDetails.field}
          sortOrder={sortDetails.order}
        />
      </tr>
    </thead>
  );
};

export default TableHeader;
